import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class CredentialTypeService extends BaseApiService {
    public getCustomerCredentialTypesForBusinessTransaction(businessTransactionId: number) {
        return this.get('Driver/CredentialType/Available/' + businessTransactionId);
    }
    public getCustomerCredentialTypesDisallowedForBusinessTransaction(businessTransactionId: number) {
        return this.get('Driver/CredentialType/Disallowed/' + businessTransactionId);
    }
    public getCredentialTypes() {
        return this.get('Driver/CredentialType/');
    }
}
